import { connect } from 'react-redux'

import component from 'components/RecurringOrders'

const mapActionCreators = {
}

const mapStateToProps = (state) => ({
  recurring_orders: state.recurring_orders
})

export default connect(mapStateToProps, mapActionCreators)(component)



// WEBPACK FOOTER //
// ./src/routes/RecurringOrders/containers/RecurringOrdersContainer.js